routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.shoppingExperience', {
      url: "shopping-experience",
      template: `<shopping-experience sh-ctrl="shCtrl" ></shopping-experience>`
    });
}

export default routesConfig;




/** WEBPACK FOOTER **
 ** ./www/components/shopping-experience/shopping-experience.config.js
 **/